export default __webpack_public_path__ + "static/RevitIcon-b40070444990e45c0890bcae4c31070f.jpg";